import moment from 'moment';
import { ageForms } from '@/shared/config/expiration-forms';
import { Pluralizer } from '@/shared/lib/string';
import { TaxNumberParser } from '@/shared/lib/tax-number';

const { extractBirthdayFromTaxNumber } = TaxNumberParser();
const { getPluralText } = Pluralizer();

export default {
  computed: {
    getVehicleYoungestDriverAgeList() {
      return Array.from({ length: 100 - 18 + 1 }, (_, i) => {
        const n = i + 18;
        return { value: n, label: getPluralText(n, ageForms.forms) };
      });
    },
    getMinDriverBirthdayYear() {
      return new moment().subtract(100, 'years').year();
    },
    getMaxDriverBirthdayYear() {
      return new moment().subtract(18, 'years').year();
    },
    getBirthdayPlaceholder() {
      return new moment().subtract(35, 'years').format('DD.MM.YYYY');
    },
  },
  methods: {
    extractBirthdayFromTaxNumber,
    getAvailableOwnerBirthdays(ownerBirthday) {
      if (!ownerBirthday) return [];

      const birthday = moment(ownerBirthday, ['YYYY-MM-DD', 'DD.MM.YYYY', 'DD-MM-YYYY', moment.ISO_8601]);
      if (!birthday.isValid()) return [];

      const fullYears = moment().diff(birthday, 'years');
      const minDate = moment().subtract(fullYears + 1, 'years').add(1, 'day').toDate();
      const maxDate = moment().subtract(fullYears, 'years').toDate();

      const result = [];
      const date = new Date(minDate);
      while (date <= maxDate) {
        result.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      return result;
    },
    calculateDriverYoungestAge(date) {
      return new moment().diff(new moment(date, ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]), 'years') || 18;
    },
    calculatePolicyholderBirthday(youngestDriverAge) {
      if (!youngestDriverAge) {
        return null;
      }

      return new moment().subtract(youngestDriverAge, 'years').subtract(1, 'day').format('DD.MM.YYYY');
    },
    clarifyOwnerBirthdayByPolicyholderBirthday(policyholderBirthday, vehicleOwnerBirthday) {
      if (!vehicleOwnerBirthday) return null;

      const formats = ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601];

      const ownerBirthDate = moment(vehicleOwnerBirthday, formats);
      const insurerBirthDate = moment(policyholderBirthday, formats);

      if (!ownerBirthDate.isValid()) return null;

      const ownerBirthFullYears = moment().diff(ownerBirthDate, 'years');
      const insurerBirthFullYears = insurerBirthDate.isValid()
        ? moment().diff(insurerBirthDate, 'years')
        : null;

      if (insurerBirthFullYears !== null && ownerBirthFullYears === insurerBirthFullYears) {
        return insurerBirthDate.format('DD.MM.YYYY');
      }

      return ownerBirthDate.format('DD.MM.YYYY');
    },
  },
};
